// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__MHrhv","leaguesTitle":"Dashboard_leaguesTitle__nG+l6","noActionsMessage":"Dashboard_noActionsMessage__-47Hq"};